import { Carousel } from '@mantine/carousel';
import { ActionIcon, Menu } from '@mantine/core';
import { bridge } from '../../globals';
import Icon from '../Icon/Icon';
import { Content, Header, Image, Wrapper } from './ShaderPopOver.style';

export type ShaderPopoverProps = {
  holodeck: IHolodeckState;
  shaders: IShader[];
  onSet: (value: Shader) => void;
};

export function ShaderPopover(props: ShaderPopoverProps) {
  const { holodeck, shaders } = props;
  const { shader } = holodeck;

  const index = shaders.findIndex((s: IShader) => s.id === shader);

  function onCarouselChange(index: number) {
    const value = shaders[index].id;
    bridge.changeShader('main', value);
    props.onSet(value);
  }

  function renderShader(shader: IShader) {
    return (
      <Carousel.Slide key={shader.id}>
        <Image src={shader.thumbUrl} />
      </Carousel.Slide>
    );
  }

  function renderShaders() {
    return shaders.map((s: IShader) => renderShader(s));
  }

  return (
    <Wrapper className='ShaderPopover-wrapper' data-testid='ShaderPopover-wrapper'>
      <Menu>
        <Menu.Target>
          <ActionIcon size='lg' variant='subtle' color='blue'>
            <Icon name='IconColorSwatch' size={20} color='#74c0fc' />
          </ActionIcon>
        </Menu.Target>
        <Menu.Dropdown style={{ position: 'absolute', transform: 'translate(-125px, 40px)' }}>
          <Content>
            <Header>Shader</Header>
            <Carousel
              orientation='vertical'
              height={180}
              withIndicators
              withControls
              initialSlide={index}
              onSlideChange={onCarouselChange}
            >
              {renderShaders()}
            </Carousel>
          </Content>
        </Menu.Dropdown>
      </Menu>
    </Wrapper>
  );
}

export default ShaderPopover;
